define('../app/fukit/behavior/confirm.invoke.method.on.event.behavior',['require','exports','module','underscore','../view/block/confirm.modal.view','./invoke.method.on.event.behavior','marionette'],function(require, exports, module) {
  //prettier-ignore
  var _                           = require('underscore'),
      ConfirmModalView            = require('../view/block/confirm.modal.view'),
      InvokeMethodOnEventBehavior = require('./invoke.method.on.event.behavior'),
      Mn                          = require('marionette');

  var ConfirmInvokeMethodOnEventBehavior = InvokeMethodOnEventBehavior.extend({
    defaults: _.extend({}, InvokeMethodOnEventBehavior.prototype.defaults, {
      // This method is called at the beginning of the onEvent method.  If preventOnEventHandler
      //  returns true, the rest of onEvent doesn't run.
      // The default allows onEvent to run always.
      preventOnEventHandler: function() {
        return false;
      },
      // the options for the modal
      modalOptions: {},
      // same as modalOptions but kept for legacy support
      confirmModalOptions: {},
      // called when the modal confirm is pressed
      onConfirm: null,
      //sometimes you don't want a modal. You need a way to shut that shit down
      suppressModal: false,
    }),

    onEvent: function() {
      if (this.getOption('suppressModal')) {
        return;
      }

      this.eventArgs = _.toArray(arguments);

      //prettier-ignore
      var args                = arguments,
          onConfirm           = this.getOption('onConfirm'),
          confirmModalOptions = Mn._getValue(this.getOption('modalOptions') || this.getOption('confirmModalOptions'), this);

      this.createConfirmModal(_.extend({ visible: true, type: ConfirmModalView }, confirmModalOptions)).on(
        'confirm',
        function() {
          if (onConfirm) {
            onConfirm.call(this, this.getTargetModel());
          }
          this.invokeMethod.apply(this, args);
        },
        this
      );
    },

    createConfirmModal: function(options) {
      if (this.view.buildComponent) {
        return this.view.buildComponent(options);
      }
      throw new Error('The ConfirmInvokeMethodOnEventBehavior was attached to a non-uikit view');
    },
  });

  module.exports = ConfirmInvokeMethodOnEventBehavior;
});

